var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceivedFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3463 4.345L9.98964 1.98833C9.67714 1.67583 9.25297 1.5 8.8113 1.5H2.83464C1.9138 1.5 1.16797 2.24583 1.16797 3.16667V14.8333C1.16797 15.7542 1.9138 16.5 2.83464 16.5H11.168C12.0888 16.5 12.8346 15.7542 12.8346 14.8333V5.52333C12.8346 5.08167 12.6588 4.6575 12.3463 4.345V4.345Z",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8346 5.66667H9.5013C9.0413 5.66667 8.66797 5.29333 8.66797 4.83333V1.5",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceivedFile);
export default __webpack_public_path__ + "static/media/ReceivedFile.39ba1caa171d6d9904351b301b7a2181.svg";
export { ForwardRef as ReactComponent };